import type {IScheduledEvent} from "~/data/events";
import moment from "moment-timezone";
import {EVENT_DATE_FORMAT} from "~/data/events";

export function useEventTZDate(event: IScheduledEvent) {
    const startDate = moment(event.dateStart, EVENT_DATE_FORMAT);
    const endDate = moment(event.dateEnd, EVENT_DATE_FORMAT);
    let periodString = `Начало <span class="s-1">${startDate.format('DD.MM.YYYY')}</span> в <span class="s-2">${startDate.format('HH:mm')}</span> <span class="small">(МСК)</span>`;
    if(startDate.unix() !== endDate.unix()) {
        if(startDate.format('DD.MM.YYYY') !== endDate.format('DD.MM.YYYY')) {
            periodString = `С <span class="s-1">${startDate.format('DD.MM.YYYY')}</span> <span class="s-2">${startDate.format('HH:mm')}</span> до  <span class="s-1">${endDate.format('DD.MM.YYYY')}</span> <span class="s-2">${endDate.format('HH:mm')}</span> <span class="small">(МСК)</span>`;
        } else if(startDate.format('HH:mm') !== endDate.format('HH:mm')) {
            periodString = `<span class="s-1">${startDate.format('DD.MM.YYYY')}</span> с  <span class="s-2">${startDate.format('HH:mm')}</span> до <span class="s-2">${endDate.format('HH:mm')}</span> <span class="small">(МСК)</span>`;
        }
    }

    return {
        startDate,
        endDate,
        startDateString: startDate.format(EVENT_DATE_FORMAT),
        endDateString: endDate.format(EVENT_DATE_FORMAT),
        period: periodString
    }
}